const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCarbonAccount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 33,
    viewBox: "0 0 31 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M30.0597 31.9596L27.3578 30.8145L24.656 31.9596L21.9541 30.8145L19.2523 31.9596L16.5504 30.8145L13.8486 31.9596L11.1454 30.8145L8.44226 31.9596",
    stroke: "#1D313D",
    style: {
      stroke: "#1D313D",
      stroke: "color(display-p3 0.1137 0.1922 0.2392)",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.44226 8.23686V1.98093C8.44226 1.37539 8.93303 0.883301 9.53989 0.883301H28.9621C29.5676 0.883301 30.0597 1.37407 30.0597 1.98093V31.9598",
    stroke: "#1D313D",
    style: {
      stroke: "#1D313D",
      stroke: "color(display-p3 0.1137 0.1922 0.2392)",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.44226 31.96V29.96",
    stroke: "#1D313D",
    style: {
      stroke: "#1D313D",
      stroke: "color(display-p3 0.1137 0.1922 0.2392)",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.933 4.48877H22.9066",
    stroke: "#1D313D",
    style: {
      stroke: "#1D313D",
      stroke: "color(display-p3 0.1137 0.1922 0.2392)",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2642 4.48877H27.8275",
    stroke: "#1D313D",
    style: {
      stroke: "#1D313D",
      stroke: "color(display-p3 0.1137 0.1922 0.2392)",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.933 8.23682H20.0464",
    stroke: "#1D313D",
    style: {
      stroke: "#1D313D",
      stroke: "color(display-p3 0.1137 0.1922 0.2392)",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2642 8.23682H27.8275",
    stroke: "#1D313D",
    style: {
      stroke: "#1D313D",
      stroke: "color(display-p3 0.1137 0.1922 0.2392)",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6006 12.271H22.9067",
    stroke: "#1D313D",
    style: {
      stroke: "#1D313D",
      stroke: "color(display-p3 0.1137 0.1922 0.2392)",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2643 12.271H27.8276",
    stroke: "#1D313D",
    style: {
      stroke: "#1D313D",
      stroke: "color(display-p3 0.1137 0.1922 0.2392)",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.205 16.4214H28.3383",
    stroke: "#1D313D",
    style: {
      stroke: "#1D313D",
      stroke: "color(display-p3 0.1137 0.1922 0.2392)",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6716 19.6216H27.805",
    stroke: "#1D313D",
    style: {
      stroke: "#1D313D",
      stroke: "color(display-p3 0.1137 0.1922 0.2392)",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6716 23.355H27.805",
    stroke: "#1D313D",
    style: {
      stroke: "#1D313D",
      stroke: "color(display-p3 0.1137 0.1922 0.2392)",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.85 27.2754H28.0809",
    stroke: "#1D313D",
    style: {
      stroke: "#1D313D",
      stroke: "color(display-p3 0.1137 0.1922 0.2392)",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0135 26.1814C10.8829 26.845 9.56499 27.2262 8.15865 27.2262C3.94757 27.2262 0.533325 23.812 0.533325 19.6009C0.533325 15.3898 3.94757 11.9756 8.15865 11.9756C12.3697 11.9756 15.784 15.3898 15.784 19.6009C15.7827 22.407 14.2682 24.8582 12.0135 26.1814Z",
    stroke: "#1D313D",
    style: {
      stroke: "#1D313D",
      stroke: "color(display-p3 0.1137 0.1922 0.2392)",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.44045 25.7073C8.31649 25.7073 8.21643 25.6135 8.21643 25.4974V20.4495C8.21643 20.3912 8.24232 20.3353 8.28812 20.2956L9.97326 18.8299C10.0639 18.7511 10.2057 18.7562 10.2899 18.8411C10.374 18.9259 10.369 19.0589 10.2779 19.1377L8.66397 20.5414V25.4979C8.66447 25.6131 8.56391 25.7073 8.44045 25.7073Z",
    fill: "#1D313D",
    stroke: "#1D313D",
    style: {
      fill: "#1D313D",
      fill: "color(display-p3 0.1137 0.1922 0.2392)",
      fillOpacity: 1,
      stroke: "#1D313D",
      stroke: "color(display-p3 0.1137 0.1922 0.2392)",
      strokeOpacity: 1
    },
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0887 20.9074C9.63876 20.9074 9.13698 20.7818 8.57698 20.5307C8.52058 20.5053 8.47771 20.454 8.46011 20.391C8.02421 18.8207 8.17357 17.6486 8.90459 16.9075C10.0408 15.7549 12.2758 16.0574 13.4175 16.5186C13.4829 16.545 13.5312 16.606 13.5456 16.6803C13.5596 16.7546 13.5375 16.8313 13.4865 16.8835C13.191 17.1884 12.9617 17.7288 12.719 18.3009C12.3981 19.0567 12.0349 19.9137 11.418 20.4286C11.0363 20.7481 10.5954 20.9074 10.0887 20.9074ZM8.82201 20.1638C11.0742 21.1268 11.7226 19.5971 12.3503 18.1177C12.5538 17.6374 12.7487 17.1786 12.9933 16.8278C11.8363 16.4492 10.0566 16.3417 9.18256 17.2285C8.58827 17.8314 8.46733 18.8183 8.82201 20.1638Z",
    fill: "#1D313D",
    stroke: "#1D313D",
    style: {
      fill: "#1D313D",
      fill: "color(display-p3 0.1137 0.1922 0.2392)",
      fillOpacity: 1,
      stroke: "#1D313D",
      stroke: "color(display-p3 0.1137 0.1922 0.2392)",
      strokeOpacity: 1
    },
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.53833 20.3743C8.51061 20.3743 8.48196 20.3699 8.45471 20.3609L6.21097 19.6191C6.10386 19.5837 6.05406 19.488 6.10057 19.4057C6.14661 19.3234 6.2711 19.2855 6.37822 19.3209L8.62196 20.0627C8.72907 20.0981 8.77887 20.1938 8.73236 20.2761C8.69806 20.3375 8.62008 20.3743 8.53833 20.3743Z",
    fill: "#1D313D",
    stroke: "#1D313D",
    style: {
      fill: "#1D313D",
      fill: "color(display-p3 0.1137 0.1922 0.2392)",
      fillOpacity: 1,
      stroke: "#1D313D",
      stroke: "color(display-p3 0.1137 0.1922 0.2392)",
      strokeOpacity: 1
    },
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54294 21.4406C6.19709 21.4406 5.87327 21.382 5.56996 21.2659C4.32371 20.7882 3.75715 19.4594 3.30219 18.3919C3.16705 18.0746 3.03943 17.7751 2.9133 17.5535C2.85374 17.4491 2.88477 17.3152 2.98337 17.2479C3.85524 16.6561 5.74414 16.3877 7.06046 16.9485C7.84475 17.2826 8.33774 17.8739 8.48589 18.6577C8.50941 18.782 8.42933 18.9022 8.30721 18.9261C8.18509 18.9501 8.06697 18.8686 8.04345 18.7443C7.92332 18.1092 7.53393 17.6472 6.88628 17.3712C5.73663 16.8817 4.18107 17.1191 3.4093 17.525C3.5109 17.7297 3.611 17.9645 3.7151 18.2095C4.13653 19.1976 4.66055 20.4271 5.72862 20.8371C6.44184 21.1106 7.35025 20.9868 8.42833 20.4699C8.54094 20.4159 8.67508 20.4648 8.72813 20.5794C8.78118 20.694 8.73314 20.8305 8.62052 20.8844C7.84675 21.2562 7.15906 21.4406 6.54294 21.4406Z",
    fill: "#1D313D",
    stroke: "#1D313D",
    style: {
      fill: "#1D313D",
      fill: "color(display-p3 0.1137 0.1922 0.2392)",
      fillOpacity: 1,
      stroke: "#1D313D",
      stroke: "color(display-p3 0.1137 0.1922 0.2392)",
      strokeOpacity: 1
    },
    strokeWidth: 0.4
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCarbonAccount);
export default __webpack_public_path__ + "static/media/icon-carbon-account.633fe3129ff18e0a12d0aa5d656c62b9.svg";
export { ForwardRef as ReactComponent };